var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useState, useEffect, useMemo, useContext } from 'react';
import { useForm, Controller, useFieldArray, } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { LoadingButton, Button, Alert, TextField, Typography, } from '@one-thd/sui-atomic-components';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { b2bAccountApi } from '../../api/b2b/account';
import { StaticField } from '../shared/static-field/static-field';
import { validationSchema } from './validation';
import { SectionHeader } from '../shared/section-header/section-header';
import { BusinessTypeSelect } from './business-type-select';
import { useProfile } from '../../hooks/use-profile';
import { getHyphenatedPhoneNumber } from '../../utils/general';
import { PHONE_PLACEHOLDER } from '../../constants/placeholders';
import { ZIPCODE_LENGTH } from '../../constants/general';
import { CityStateSelect, formatCityState, } from '../shared/city-state-select/city-state-select';
import { addressesApi } from '../../api/common/addresses';
import { ZIPCODE_REGEX } from '../../constants/regex';
import { ERRORS_CODE, ERR_INVALID_ZIP, ERR_PHONE, ERR_SAVE, } from '../../constants/response-error-messages';
import { findTradeTypeInfo, getDeleteAltPhonesPayload, getInitialCompanyDetailsValues, mapCompanyFormToRequestModel, } from '../../utils/company-details';
import { AlternatePhones } from './alternate-phones/alternate-phones';
import { COMPANY_ADDRESS_TOOLTIP, COMPANY_PHONE_TOOLTIP, } from '../../constants/tooltip';
import { setEditEvent, pushErrorEvent } from '../../utils/analytics';
import { getTextFieldStatus } from '../../utils/form';
import { InfoPopover } from '../shared/popover/popover';
export var CompanyDetails = function () {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    var _j = useState(false), isEdit = _j[0], setIsEdit = _j[1];
    var _k = useState(true), isInitialZipCode = _k[0], setIsInitialZipCode = _k[1];
    var _l = useState(false), showSuccessAlert = _l[0], setSuccessAlert = _l[1];
    var _m = useState(null), errorMsg = _m[0], setErrorMsg = _m[1];
    var _o = useState(false), pendingZipCode = _o[0], setPendingZipCode = _o[1];
    var _p = useProfile(), customerData = _p.customerData, updateCompanyDetails = _p.updateCompanyDetails;
    var _q = useState(null), tradeTypes = _q[0], setTradeTypes = _q[1];
    var _r = useState(false), loading = _r[0], setLoading = _r[1];
    var _s = useContext(ExperienceContext), isConsumerApp = _s.isConsumerApp, channel = _s.channel;
    var isMobile = channel === 'mobile';
    var sizeIcon = isMobile ? 'small' : 'regular';
    var placement = isMobile ? 'bottom' : 'right';
    var isZipCodeError = (errorMsg === null || errorMsg === void 0 ? void 0 : errorMsg.message) === ERR_INVALID_ZIP.message;
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    var companyDetails = customerData.companyDetails;
    var isCityState = !!(companyDetails.city && companyDetails.state);
    var defaultValues = useMemo(function () { return getInitialCompanyDetailsValues(companyDetails); }, [companyDetails]);
    var _t = useForm({
        resolver: yupResolver(validationSchema),
        defaultValues: defaultValues,
        mode: 'onTouched',
    }), register = _t.register, formState = _t.formState, setValue = _t.setValue, reset = _t.reset, control = _t.control, handleSubmit = _t.handleSubmit;
    var errors = formState.errors, isValid = formState.isValid, dirtyFields = formState.dirtyFields;
    var alternatePhoneFields = useFieldArray({
        control: control,
        name: 'alternatePhones',
    });
    var isAccountOwner = (customerData === null || customerData === void 0 ? void 0 : customerData.accountOwner) === 'Y';
    var handleOnChangePhone = function (event) {
        setValue('companyPhone', getHyphenatedPhoneNumber(event.currentTarget.value || ''));
    };
    var handleEditClick = function () {
        setIsEdit(true);
        setSuccessAlert(false);
    };
    var handleFormReset = function () {
        reset(defaultValues);
        resetEditState();
    };
    var resetEditState = function () {
        setIsEdit(false);
        setErrorMsg(null);
        setIsInitialZipCode(true);
    };
    var _u = useState(isCityState
        ? [{ city: companyDetails.city, state: companyDetails.state }]
        : null), cities = _u[0], setCities = _u[1];
    useEffect(function () {
        b2bAccountApi
            .getTradeTypes()
            .then(function (_a) {
            var data = _a.data;
            return setTradeTypes(data === null || data === void 0 ? void 0 : data.tradeTypes);
        });
    }, []);
    useEffect(function () {
        if (isEdit) {
            loadCities(defaultValues.zipCode);
        }
    }, [isEdit]);
    useEffect(function () {
        reset(defaultValues);
    }, [defaultValues]);
    var loadCities = function (zipCode) {
        var isValidZipCode = zipCode.match(ZIPCODE_REGEX);
        if (isValidZipCode) {
            setPendingZipCode(true);
            addressesApi
                .getPostalList(zipCode)
                .then(function (data) {
                var _a, _b;
                setErrorMsg(null);
                setCities(data);
                if (!isInitialZipCode)
                    setValue('cityState', formatCityState((_a = data[0]) === null || _a === void 0 ? void 0 : _a.city, (_b = data[0]) === null || _b === void 0 ? void 0 : _b.state));
            })
                .catch(function (errorCode) {
                if (!isInitialZipCode) {
                    setValue('cityState', '');
                    setErrorMsg(ERR_INVALID_ZIP);
                    setCities(null);
                    pushErrorEvent('company details: zip code', 'inline', errorCode || 'n/a', ERR_INVALID_ZIP.message);
                }
            })
                .finally(function () {
                setIsInitialZipCode(false);
                setPendingZipCode(false);
            });
        }
    };
    var handleZipCodeChange = function (event) {
        var newZipCode = event.currentTarget.value;
        loadCities(newZipCode);
    };
    var removePhones = function (removedPhones) { return __awaiter(void 0, void 0, void 0, function () {
        var isRemovingFailed, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!(removedPhones === null || removedPhones === void 0 ? void 0 : removedPhones.length)) return [3 /*break*/, 4];
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, b2bAccountApi.deleteAltPhone(removedPhones.map(function (value) { return (__assign(__assign({}, value), { id: undefined })); }))];
                case 2:
                    _b.sent();
                    removedPhones.forEach(function (phone) {
                        setEditEvent('profile page: edit: company details', 
                        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                        "alt phone ".concat(phone.id + 1));
                    });
                    return [3 /*break*/, 4];
                case 3:
                    _a = _b.sent();
                    isRemovingFailed = true;
                    setErrorMsg(ERR_SAVE);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/, isRemovingFailed];
            }
        });
    }); };
    var trackEditedFields = function (values) {
        var _a, _b, _c;
        if (values.companyName !== defaultValues.companyName) {
            setEditEvent('profile page: edit: company details', 'company name');
        }
        if (values.address !== defaultValues.address) {
            setEditEvent('profile page: edit: company details', 'address');
        }
        if (values.addressLine2 !== defaultValues.addressLine2) {
            setEditEvent('profile page: edit: company details', 'address line 2');
        }
        if (values.zipCode !== defaultValues.zipCode) {
            setEditEvent('profile page: edit: company details', 'zipcode');
        }
        if (values.companyPhone !== defaultValues.companyPhone) {
            setEditEvent('profile page: edit: company details', 'company phone');
        }
        if (values.businessType !== defaultValues.businessType) {
            setEditEvent('profile page: edit: company details', 'business type');
        }
        if (values.cityState !== defaultValues.cityState) {
            setEditEvent('profile page: edit: company details', 'city state');
        }
        if (isAlternatePhonesDirty(values) &&
            ((_a = values === null || values === void 0 ? void 0 : values.alternatePhones) === null || _a === void 0 ? void 0 : _a.length) >= ((_b = defaultValues === null || defaultValues === void 0 ? void 0 : defaultValues.alternatePhones) === null || _b === void 0 ? void 0 : _b.length)) {
            values.alternatePhones.forEach(function (altPhone, index) {
                var _a, _b;
                if (altPhone.number !== ((_a = defaultValues === null || defaultValues === void 0 ? void 0 : defaultValues.alternatePhones[index]) === null || _a === void 0 ? void 0 : _a.number) ||
                    altPhone.type !== ((_b = defaultValues === null || defaultValues === void 0 ? void 0 : defaultValues.alternatePhones[index]) === null || _b === void 0 ? void 0 : _b.type)) {
                    setEditEvent('profile page: edit: company details', "alt phone ".concat(typeof altPhone.id !== 'undefined' ? altPhone.id + 1 : index + 1));
                }
            });
        }
        if (isConsumerApp) {
            (_c = window === null || window === void 0 ? void 0 : window.LIFE_CYCLE_EVENT_BUS) === null || _c === void 0 ? void 0 : _c.trigger('NATIVE_APP.COMPANY_INFO', {
                companyName: values === null || values === void 0 ? void 0 : values.companyName,
                businessType: values === null || values === void 0 ? void 0 : values.businessType,
            });
        }
    };
    var isAlternatePhonesDirty = function (formValues) {
        var newAltPhonesValues = formValues.alternatePhones.filter(function (_a) {
            var number = _a.number;
            return !!number;
        });
        var isAlternatePhonesLengthChanged = defaultValues.alternatePhones.length !== newAltPhonesValues.length;
        var isAlternatePhonesChanged = function () {
            return defaultValues.alternatePhones.some(function (_a, index) {
                var number = _a.number, type = _a.type;
                return number !== newAltPhonesValues[index].number ||
                    type !== newAltPhonesValues[index].type;
            });
        };
        return isAlternatePhonesLengthChanged || isAlternatePhonesChanged();
    };
    var isFormDirty = function (formValues) {
        return Object.entries(dirtyFields).some(function (_a) {
            var key = _a[0], value = _a[1];
            if (Array.isArray(value) && key === 'alternatePhones') {
                return isAlternatePhonesDirty(formValues);
            }
            return value || false;
        });
    };
    var onSubmitForm = function (values) { return __awaiter(void 0, void 0, void 0, function () {
        var isInvalidForm, removedPhones, isRemovingAltPhonesFailed_1, requestData;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!isFormDirty(values)) {
                        setIsEdit(false);
                        reset(defaultValues);
                        return [2 /*return*/];
                    }
                    isInvalidForm = !isValid || pendingZipCode || isZipCodeError;
                    if (!!isInvalidForm) return [3 /*break*/, 2];
                    setLoading(true);
                    removedPhones = getDeleteAltPhonesPayload(values, customerData);
                    return [4 /*yield*/, removePhones(removedPhones)];
                case 1:
                    isRemovingAltPhonesFailed_1 = _a.sent();
                    requestData = mapCompanyFormToRequestModel(values, tradeTypes, 
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    customerData, isRemovingAltPhonesFailed_1 ? removedPhones : undefined);
                    updateCompanyDetails(requestData)
                        .then(function () {
                        if (!isRemovingAltPhonesFailed_1) {
                            resetEditState();
                            setSuccessAlert(true);
                            trackEditedFields(values);
                        }
                    })
                        .catch(function (errorCode) {
                        if (errorCode === ERRORS_CODE.ERR_PHONE) {
                            setErrorMsg(ERR_PHONE);
                            pushErrorEvent('company details', 'inline', errorCode || 'n/a', ERR_PHONE.message);
                        }
                        else {
                            setErrorMsg(ERR_SAVE);
                            pushErrorEvent('company details', 'inline', errorCode || 'n/a', ERR_SAVE.message);
                        }
                    })
                        .finally(function () {
                        setLoading(false);
                    });
                    _a.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    }); };
    var businessTypeDescription = ((_b = findTradeTypeInfo(tradeTypes, ((_a = companyDetails.businessType) === null || _a === void 0 ? void 0 : _a.type) || '')) === null || _b === void 0 ? void 0 : _b.description) || '';
    var generateTooltip = function (_a) {
        var message = _a.message, title = _a.title;
        return (React.createElement(Typography, { weight: "bold", variant: "body-base" },
            title,
            React.createElement(InfoPopover, { iconsize: sizeIcon, message: message, placement: placement })));
    };
    return (React.createElement("div", null,
        React.createElement(SectionHeader, { title: "COMPANY DETAILS", isBtnEnabled: isAccountOwner, actionLabel: !isEdit ? 'Edit' : 'Cancel', onActionClick: !isEdit ? handleEditClick : handleFormReset, dataTestIdBtn: !isEdit ? 'companyDetailsEditBtn' : 'companyDetailsHeaderCancelBtn' }),
        showSuccessAlert && (React.createElement("div", { className: "sui-mb-8" },
            React.createElement(Alert, { status: "success", onClose: function () { return setSuccessAlert(false); } }, "Changes saved"))),
        !isEdit && (React.createElement("div", { className: "sui-grid sui-grid-cols-1 sui-gap-4 sm:sui-gap-0" },
            React.createElement(StaticField, { title: "Company Name", content: defaultValues.companyName, dataTestIdTitle: "companyNameLabel", dataTestIdContent: "companyNameValue" }),
            React.createElement(StaticField, { title: "Business Type", content: businessTypeDescription, dataTestIdTitle: "businessTypeLabel", dataTestIdContent: "businessTypeValue" }),
            React.createElement(StaticField, { title: generateTooltip({
                    iconsize: sizeIcon,
                    message: COMPANY_ADDRESS_TOOLTIP,
                    title: 'Company Address',
                }), content: React.createElement(React.Fragment, null,
                    defaultValues.address && React.createElement("p", null, defaultValues.address),
                    defaultValues.addressLine2 && (React.createElement("p", null, defaultValues.addressLine2)),
                    React.createElement("p", null,
                        defaultValues.cityState,
                        "\u00A0",
                        defaultValues.zipCode)), contentComponent: "div", dataTestIdContent: "companyAddressValue" }),
            React.createElement(StaticField, { title: generateTooltip({
                    iconsize: sizeIcon,
                    message: COMPANY_PHONE_TOOLTIP,
                    title: 'Company Phone',
                }), content: defaultValues.companyPhone, dataTestIdContent: "companyPhoneValue" }), (_c = defaultValues === null || defaultValues === void 0 ? void 0 : defaultValues.alternatePhones) === null || _c === void 0 ? void 0 :
            _c.map(function (_a, index) {
                var number = _a.number;
                return (React.createElement(StaticField, { key: number, title: "Alternate Phone", content: number, dataTestIdTitle: "alternatePhone".concat(index, "Label"), dataTestIdContent: "alternatePhone".concat(index, "Value") }));
            }))),
        isEdit && (React.createElement("form", { className: "sui-grid sui-grid-cols-6 sui-gap-y-5 lg:sui-gap-y-8", onSubmit: handleSubmit(onSubmitForm) },
            React.createElement("div", { className: "sui-col-span-6 lg:sui-col-span-5" },
                React.createElement(TextField, { fullWidth: true, id: "companyName", label: "Company Name", status: getTextFieldStatus(errors.companyName), statusMessage: (_d = errors.companyName) === null || _d === void 0 ? void 0 : _d.message, InputProps: __assign(__assign({}, register('companyName')), { inputProps: {
                            maxLength: 60,
                            'data-testid': 'profile-company-name-inpt',
                        } }) })),
            React.createElement("div", { className: "sui-col-span-6 lg:sui-col-span-5" },
                React.createElement(Controller, { control: control, name: "businessType", render: function (_a) {
                        var field = _a.field;
                        var ref = field.ref, rest = __rest(field, ["ref"]);
                        return (React.createElement(BusinessTypeSelect, __assign({ "data-testid": "businessType", tradeTypes: tradeTypes }, rest)));
                    } })),
            React.createElement("div", { className: "sui-col-span-6 lg:sui-col-span-5" },
                React.createElement(TextField, { fullWidth: true, id: "companyAddress", label: generateTooltip({
                        iconsize: sizeIcon,
                        message: COMPANY_ADDRESS_TOOLTIP,
                        title: 'Company Address',
                    }), status: getTextFieldStatus(errors.address), statusMessage: (_e = errors.address) === null || _e === void 0 ? void 0 : _e.message, InputProps: __assign(__assign({}, register('address')), { inputProps: {
                            'data-testid': 'profile-company-address-inpt',
                        } }) })),
            React.createElement("div", { className: "sui-col-span-6 lg:sui-col-span-5" },
                React.createElement(TextField, { fullWidth: true, id: "companyAddressLine2", label: "Address Line 2", optional: true, status: getTextFieldStatus(errors.addressLine2), statusMessage: (_f = errors.addressLine2) === null || _f === void 0 ? void 0 : _f.message, InputProps: __assign(__assign({}, register('addressLine2')), { inputProps: {
                            'data-testid': 'profile-company-address2-inpt',
                        } }) })),
            React.createElement("div", { className: "sui-col-span-6 lg:sui-col-span-5" },
                React.createElement(TextField, { fullWidth: true, label: "ZIP Code", id: "zipCode", status: getTextFieldStatus(errors.zipCode), statusMessage: (_g = errors.zipCode) === null || _g === void 0 ? void 0 : _g.message, InputProps: __assign(__assign({}, register('zipCode', { onChange: handleZipCodeChange })), { inputProps: {
                            maxLength: ZIPCODE_LENGTH,
                            'data-testid': 'profile-company-zip-code-inpt',
                        } }) })),
            React.createElement("div", { className: "sui-col-span-6 lg:sui-col-span-5" },
                React.createElement(Controller, { control: control, name: "cityState", render: function (_a) {
                        var field = _a.field;
                        var ref = field.ref, rest = __rest(field, ["ref"]);
                        return (React.createElement(CityStateSelect, __assign({ "data-testid": "cityState", cities: cities }, rest)));
                    } })),
            React.createElement("div", { className: "sui-col-span-6 lg:sui-col-span-5" },
                React.createElement(TextField, { fullWidth: true, id: "companyPhone", label: generateTooltip({
                        iconsize: sizeIcon,
                        message: COMPANY_PHONE_TOOLTIP,
                        title: 'Company Phone',
                    }), placeholder: PHONE_PLACEHOLDER, status: getTextFieldStatus(errors.companyPhone), statusMessage: (_h = errors.companyPhone) === null || _h === void 0 ? void 0 : _h.message, InputProps: __assign(__assign({}, register('companyPhone', {
                        onChange: handleOnChangePhone,
                    })), { inputProps: {
                            'data-testid': 'profile-company-phone-inpt',
                        } }) })),
            React.createElement(AlternatePhones, { register: register, control: control, fields: alternatePhoneFields, setValue: setValue, formState: formState }),
            errorMsg && (React.createElement("div", { className: "sui-col-span-6 lg:sui-col-span-5" },
                React.createElement(Alert, { status: "error" }, errorMsg.message))),
            React.createElement("div", { className: "sui-col-span-6 lg:sui-col-span-5 sui-grid sui-grid-cols-1 sui-gap-5 sm:sui-grid-cols-2" },
                React.createElement("div", { className: "sui-order-1 sm:sui-order-2" },
                    React.createElement(LoadingButton, { fullWidth: true, loading: loading, variant: "primary", type: "submit", "data-testid": "companyDetailsSaveBtn" }, "Save Changes")),
                React.createElement("div", { className: "sui-order-2 sm:sui-order-1" },
                    React.createElement(Button, { type: "button", variant: "secondary", onClick: handleFormReset, fullWidth: true, "data-testid": "companyDetailsCancelBtn" }, "Cancel")))))));
};
